import { render } from "./themify_icon.vue?vue&type=template&id=387d640a"
import script from "./themify_icon.vue?vue&type=script&lang=js"
export * from "./themify_icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__